import './App.css';
import Navbar from './content/navbar/navbar.js';
import Front from './content/middle content/Front';
import Skills from './content/skills/Skills';
import AboutMe from './content/about me/AboutMe';
import Project from './content/Project/Project';
import Contact from './content/contact me/Contact';
import { BrowserRouter, Route, Switch } from 'react-router-dom';



function App() {
  
  return (
    <><BrowserRouter>
          <Navbar navbarname='Avanish Chandra Pandey' navElement1='Home'navElement2='Projects'navElement3='Contact'navElement4='About'/>
    <Switch>
      <Route index exact path='/' >
          <Front/>    
          <Skills/>
          <AboutMe/> 
          <Contact/>
      </Route>
      <Route exact path="/Project">
          <Project/>
      </Route>
    </Switch>

    </BrowserRouter>
    </>
  );
}

export default App;
